module.exports = {
    "owner": "f142ef84-3383-4f16-9dd0-eb26f0d02c65",
    "id": "6cf26281-d195-46c9-bfb7-9a91685c4d3e",
    "account": "EURO",
    "details": {
        "AddressLine2": "Brno CZ Czech Republic",
        "AddressLine1": "Kamenickova 1114 2 Zabovresky 616 02",
        "Currency": "USD",
        "CreditorType": "Organisation",
        "AccountIdentifier": "GB17CLJU00997129900158",
        "Beneficiary Name": "Safe Payments Solutions s.r.o.",
        "CountryCode": "CZ",
        "BankIdentifier": "CLJUGB21"
    },
    "transfer_type": "SWIFT"
};